module.exports = __webpack_public_path__ + "static/media/SupportIconActive.dd67fff8.svg";